"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionsStoreInternalAdapter = void 0;
var PermissionsStoreInternalAdapter = /** @class */ (function () {
    function PermissionsStoreInternalAdapter() {
    }
    Object.defineProperty(PermissionsStoreInternalAdapter, "PermissionsStore", {
        get: function () {
            return window.permissionsStore;
        },
        enumerable: false,
        configurable: true
    });
    PermissionsStoreInternalAdapter.refreshPermissions = function (permissions) {
        this.PermissionsStore.refresh(permissions);
    };
    return PermissionsStoreInternalAdapter;
}());
exports.PermissionsStoreInternalAdapter = PermissionsStoreInternalAdapter;
